module.exports = __webpack_public_path__ + "static/media/conf_icon.60cd3b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/conf_icon.png
// module id = 200
// module chunks = 0